import { TableColumn } from "../components/finance/ReimbursementPhysicalVoucher";

export const columnsAdmin: TableColumn[] = [
  
  { key: "selectAll", header: "Select", isCheckbox: true },
  { key: "reportId", header: "Report ID"},
  { key: "merchant", header: "Merchant"},
  { key: "companyName", header: "Company Name"},
  { key: "totalAmount", header: "Total Amount"},
  { key: "noOfVouchers", header: "No. of Vouchers" },
  { key: "submissionDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  { key: "rejectionReason", header: "Rejection Reason" },
  { key: "createdBy", header: "Created By"},
  { key: "status", header: "Report Status"},
];
export const columnsMerchant: TableColumn[] = [
  { key: "reportId", header: "Report ID"},
  { key: "companyName", header: "Company Name"},
  { key: "totalAmount", header: "Total Amount"},
  { key: "noOfVouchers", header: "No. of Vouchers" },
  { key: "submissionDate", header: "Submitted Date" },
  { key: "receivedDate", header: "Received Date" },
  { key: "rejectionReason", header: "Rejection Reason" },
  { key: "createdBy", header: "Created By" },
  { key: "status", header: "Report Status"},
];

export const metaData = {
  reportId: {
    isImage: false,
    linkTo: "",
  },
  merchant: {
    isImage: false,
    linkTo: "",
  },
  companyName: {
    isImage: false,
    linkTo: "",
  },
  voucherType: {
    isImage: false,
    linkTo: "",
  },
  totalAmount: {
    isImage: false,
    linkTo: "",
  },
  noOfVouchers: {
    isImage: false,
    linkTo: "",
  },
  submissionDate: {
    isImage: false,
    linkTo: "",
  },
  receivedDate: {
    isImage: false,
    linkTo: "",
  },
  rejectionReason: {
    isImage: false,
    linkTo: "",
  },
  createdBy: {
    isImage: false,
    linkTo: "",
  },
  status: {
    isImage: false,
    linkTo: "",
  },
};
